import React from 'react';
import Marquee from 'react-fast-marquee';

export default function EditorialMarquee() {
  const items = [
    'Mariages',
    'Bar mobile',
    'Cocktails d\'auteur',
    'Occitanie',
    'Sud de la France',
    'Barman privé',
    'Signature',
  ];
  return (
    <section className="relative py-16 md:py-24 border-y border-char/10 overflow-hidden" data-testid="marquee-section">
      <Marquee gradient gradientColor="#F4EFE5" gradientWidth={140} speed={38} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span key={i} className={`marquee-text ${i % 2 === 0 ? 'marquee-fill' : ''}`}>
            {t}
            <span className="dot">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
